"use strict";
/**
 * Venue status API — health snapshot for both trading venues.
 *
 * Read-only, off any order path. The server serves this from an in-memory
 * store fed by the connection-warmer heartbeat (see server venue-status.ts).
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchVenueStatus = fetchVenueStatus;
const request_1 = require("./request");
/** GET /api/venue-status — current health of Kalshi and Polymarket US. */
async function fetchVenueStatus() {
    return (0, request_1.apiRequest)("GET", "/api/venue-status");
}
